import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from '../../utils/apiBase';

const LocationList = () => {
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch Data from API
    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/agentLocation/getLocations`)
            .then((response) => {
                setLocations(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    }, []);

    return (
        <div style={{ padding: "20px" }}>
        <h2>Uploaded Location Data</h2>
        {loading ? (
            <p>Loading...</p>
        ) : locations.length === 0 ? (
            <p>No data available</p>
        ) : (
            <table border="1" cellPadding="10">
                <thead>
                    <tr>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Address</th>
                        <th>Photo</th>
                        <th>Timestamp</th>
                    </tr>
                </thead>
                <tbody>
                    {locations.map((location, index) => (
                        <tr key={index}>
                            <td>{location.latitude}</td>
                            <td>{location.longitude}</td>
                            <td>{location.address}</td>
                            <td>
                                {location.photo ? (
                                    <img
                                        src={location.photo}  // ✅ Display Base64 Image
                                        alt="Uploaded"
                                        width="100"
                                    />
                                ) : "No Photo"}
                            </td>
                            <td>{new Date(location.createdAt).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}
    </div>
    );
};

export default LocationList;
